import { call, put, take, takeLatest, fork, cancel } from 'redux-saga/effects'
import type { Task as SagaTask } from 'redux-saga'
import type { PayloadAction } from '@reduxjs/toolkit'
import { doc } from 'firebase/firestore'
import { db } from '../../lib/firebase'
import { createSnapshotChannel } from '../utils/createSnapshotChannel'
import {
    startAgentStatusListening,
    stopAgentStatusListening,
    setAgentStatus,
    clearAgentStatus,
} from './agentStatusSlice'

// Listen to the per-task "agent is working" flag (agent_status/{taskId}) while the task is
// open, so the activity can show a "thinking…" indicator (SCD-589).
function* listenAgentStatus(taskId: string): Generator<any, void, any> {
    yield put(clearAgentStatus())

    const channel = yield call(createSnapshotChannel, doc(db, 'agent_status', taskId))

    try {
        while (true) {
            const event: any = yield take(channel)
            if (event.type === 'data') {
                const snap = event.snapshot
                if (snap.exists()) {
                    const data = snap.data()
                    yield put(setAgentStatus({
                        taskId,
                        working: !!data.working,
                        startedAt: data.startedAt ? { seconds: data.startedAt.seconds } : null,
                    }))
                } else {
                    yield put(clearAgentStatus())
                }
            }
        }
    } finally {
        channel.close()
    }
}

function* agentStatusSubscriptionWorker(action: PayloadAction<{ taskId: string; workspaceId: string }>): Generator<any, void, any> {
    const listener: SagaTask = yield fork(listenAgentStatus, action.payload.taskId)
    yield take(stopAgentStatusListening.type)
    yield cancel(listener)
    yield put(clearAgentStatus())
}

export function* watchAgentStatusSaga() {
    yield takeLatest(startAgentStatusListening.type, agentStatusSubscriptionWorker)
}
